import React from 'react';
import { Link } from 'react-router-dom';
import arrowIcon from '../../assets/icons/button-arrow.svg';
import './buttonContact.css';

const ButtonContact = ({ children, to, onClick, variant = 'default' }) => {
  const className = `kw__button-contact kw__button-contact--${variant}`;

  if (to) {
    return (
      <Link to={to} className={className}>
        <span className="kw__button-contact_text">{children}</span>
        <span className="kw__button-contact_icon">
          <img src={arrowIcon} alt="" />
        </span>
      </Link>
    );
  }

  return (
    <button type="button" className={className} onClick={onClick}>
      <span className="kw__button-contact_text">{children}</span>
      <span className="kw__button-contact_icon">
        <img src={arrowIcon} alt="" />
      </span>
    </button>
  );
};

export default ButtonContact;
